import {testIdProps} from '@github-ui/test-id-props'
import {IssueTracksIcon} from '@primer/octicons-react'

import {useAutomationGraph} from '../../../state-providers/workflows/use-automation-graph'
import {WorkflowResources} from '../../../strings'
import {AutomationBlock} from './automation-block'
import styles from './get-sub-issues-block.module.css'

export const GetSubIssuesBlock = () => {
  const {isEditing} = useAutomationGraph()
  return (
    <AutomationBlock
      icon={IssueTracksIcon}
      iconBg="var(--bgColor-accent-muted)"
      iconColor="accent.fg"
      headerDescription={WorkflowResources.getSubIssuesBlockLabel}
      {...testIdProps('automation-get-sub-issues-block')}
    >
      {isEditing && (
        <div>
          <div className={styles.Box}>
            Enabling this workflow will automatically add sub-issues in the following scenarios:
            <ul className={styles.Box_1}>
              <li>When a sub-issue is added to an issue in the project</li>
              <li>When an issue with sub-issues is added to the project</li>
            </ul>
          </div>
          <div>Note: This workflow will initially add all existing sub-issues of issues in the project.</div>
        </div>
      )}
    </AutomationBlock>
  )
}

try{ GetSubIssuesBlock.displayName ||= 'GetSubIssuesBlock' } catch {}